// WOW Journey API client — talks to /api/wow-journey/*
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const client = axios.create({ baseURL: `${BASE}/api/wow-journey`, timeout: 20000 });

export async function createPlan(request) {
  const { data } = await client.post("/plan", request);
  return data;
}

export async function refinePlan(plan_id, action) {
  const { data } = await client.post("/refine", { plan_id, action });
  return data;
}

export const FEATURE_ENABLED = String(process.env.REACT_APP_WOW_JOURNEY_ENABLED || "").toLowerCase() === "true";
